/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { ComponentBulkUpdateListItemDto } from './component-bulk-update-list-item.dto';

export const ComponentBulkUpdateListItemMapper = entity<ComponentBulkUpdateListItemDto>({});
